<template>
  <div class="container-fluid section-show" v-if="shows && shows.length > 0">
    <!-- <div class="columns is-gapless is-mobile is-centered is-multiline" style="margin-bottom:5em;">
      <div class="column has-text-centered show-title-wrapper">
        <div class="show-title-content">
          <span class="show-title">
            {{ type === 'upcoming' ? 'Upcoming Shows' : '' }}
            {{ type === 'previous' ? 'Previous Shows' : '' }}
          </span>
        </div>
      </div>
    </div> -->
    <div class="columns show-wrapper-outer is-gapless is-flex-mobile is-multiline" :class="[{ 'is-centered': (shows && shows.length == 1) }]">
      <div v-for="(show, index) in shows" class="column show-wrapper has-text-centered" :class="{ 'is-6': split === 2, 'is-4': split === 3, 'is-half-mobile': type === 'previous', 'is-half-mobile': type === 'upcoming' }" data-aos="fade-up" data-aos-once="true" :data-aos-delay="((index % (isDesktop ? split : 2)) * 300)">
        <div class="show-content" v-if="!show.isMore">
          <div class="focus-image-wrapper show-image-wrapper">
            <!-- <a :href="'/show-detail?id=' + show.id"> -->
            <a :href="''" @click="$event.preventDefault()" style="cursor:auto;">
              <img class="image square img-responsive" :style="[{
              'background-image': 'url(' + show.image.path + ')'
              }]" />
              <div class="show-text-overlay">
                <div class="show-text-wrapper">
                  <!-- <span style="font-size:2em;color:white;">hello123</span> -->
                  <!-- <span class="date">{{ show.date_actual | dateonly }}</span><br /> -->
                  <span class="title">{{ show.title }}</span><br />
                  <span class="subtitle">{{ show.subtitle }}</span><br />
                  <!-- <a :href="show.url_1" target="_blank"><div class="button buy-ticket" :class="show.btnClass" v-if="type === 'upcoming'">
                    BUY TICKETS
                  </div></a> -->
                </div>
              </div>
            </a>
          </div>
          <!-- <span class="date">{{ show.date_actual | dateonly }}</span><br />
          <span class="title">{{ show.title }}</span><br />
          <a :href="show.url_1" target="_blank"><div class="button buy-ticket" :class="show.btnClass" v-if="type === 'upcoming'">
            BUY TICKETS
          </div></a> -->
        </div>
        <div class="show-content" v-else>
          <div class="focus-image-wrapper show-image-wrapper">
            <a :href="'mailto:info@clientmanagementprobation.com?subject=Message from CMS'" target="_blank">
            <!-- <a :href="[ '/shows?type=' + type ]"> -->
              <img class="image square img-responsive" :style="[{
              'background-image': 'url(' + show.image.path + ')'
              }]" />
              <div class="show-text-overlay visible">
                <div class="show-text-wrapper">
                  <!-- <span style="font-size:2em;color:white;">hello123</span> -->
                  <!-- <span class="date">{{ show.date_actual | dateonly }}</span><br /> -->
                  <span class="title">Looking For Representation?</span><br />
                  <span class="subtitle">EMAIL US</span>
                  <!-- <a :href="show.url_1" target="_blank"><div class="button buy-ticket" :class="show.btnClass" v-if="type === 'upcoming'">
                    BUY TICKETS
                  </div></a> -->
                </div>
              </div>
            </a>
            <!-- <div class="see-all-wrapper">
              <div>
                <span class="title">Looking For Representation?</span><br />
                <span class="subtitle">EMAIL US</span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="control notification is-danger" v-if="error">
      <button class="delete" @click="error = undefined"></button>
      <p v-html="error">
      </p>
    </div> -->
  </div>
</template>

<script>
  // import Site from '@/apis/Site'
  // import ImageMoreBg from '@/assets/thumb_6.jpg'
  // import ShowDown from 'showdown'
  // import Thumb1 from '@/assets/thumb_1.jpg'
  // import Thumb2 from '@/assets/thumb_2.jpg'
  // import Thumb3 from '@/assets/thumb_3.jpg'
  // import Thumb4 from '@/assets/thumb_4.jpg'
  // import Thumb5 from '@/assets/thumb_5.jpg'

  export default {
    name: 'about',
    props: [
      'type',
      'full'
    ],
    components: {
    },
    data () {
      return {
        isDesktop: true,
        split: 3,
        shows: [],
        error: undefined,
        loading: false
      }
    },
    computed: {
    },
    watch: {
    },
    created () {
    },
    mounted () {
      this.refresh()

      // on event resize
      this.isDesktop = (window.innerWidth >= 769)
      window.addEventListener('resize', function (event) {
        // console.log('on viewport change')
        this.isDesktop = (event.target.innerWidth >= 769)
      }.bind(this))
    },
    methods: {
      onScrollTo: function (name) {
        this.$scrollTo('#' + name)
      }.bind(this),

      getItems: function (onComplete) {
        this.loading = true
        this.error = undefined
        this.shows = []
        this.loading = false
        if (onComplete) {
          onComplete([{
            title: 'Chris Chew',
            subtitle: 'Photographer, Filmmaker, Visual Artist',
            date_actual: '2019-08-12 16:13:33',
            // url_1: 'http://www.google.com',
            image: {
              path: '' // Thumb1
            }
          }, {
            title: 'Yuna',
            subtitle: 'R&B Singer-Songwriter',
            date_actual: '2019-08-12 16:13:33',
            // url_1: 'http://www.google.com',
            image: {
              path: '' // Thumb2
            }
          }, {
            title: 'Midnight Fusic',
            subtitle: 'Indie Rock',
            date_actual: '2019-08-12 16:13:33',
            // url_1: 'http://www.google.com',
            image: {
              path: '' // Thumb3
            }
          }, {
            title: 'Project EAR',
            subtitle: 'Southeast Asia Rock Collective',
            date_actual: '2019-08-12 16:13:33',
            // url_1: 'http://www.google.com',
            image: {
              path: '' // Thumb4
            }
          }, {
            title: 'Shoffy',
            subtitle: 'Singer-Songwriter',
            date_actual: '2019-08-12 16:13:33',
            // url_1: 'http://www.google.com',
            image: {
              path: '' // Thumb5
            }
          }])
        }
        // if (this.type === 'upcoming') {
        //   Site.eventUpcoming()
        //   .then((data) => {
        //     // console.log('upcoming:', data)
        //     this.loading = false
        //     if (onComplete) {
        //       onComplete(data)
        //     }
        //   })
        //   .catch((error) => {
        //     this.loading = false
        //     this.error = 'Unable to load, please kindly refresh the page.'
        //     console.log(error)
        //   })
        // } else if (this.type === 'previous') {
        //   Site.eventPrevious()
        //   .then((data) => {
        //     console.log('previous:', data)
        //     this.loading = false
        //     if (onComplete) {
        //       onComplete(data)
        //     }
        //   })
        //   .catch((error) => {
        //     this.loading = false
        //     this.error = 'Unable to load, please kindly refresh the page.'
        //     console.log(error)
        //   })
        // }
      },
      refresh: function () {
        this.getItems((items) => {
          if (items && items.length > 0) {
            if (items.length === 1 || items.length === 2 || items.length === 4) {
              this.split = 2
            } else {
              this.split = 3
            }
            for (var i = 0; i < items.length; i++) {
              if (i % 3 === 0) {
                items[i].btnClass = 'is-green'
              } else if (i % 3 === 1) {
                items[i].btnClass = 'is-red'
              } else {
                items[i].btnClass = 'is-blue'
              }
            }
            var allItems = []
            if (this.full === 'true') {
              allItems = items
            } else {
              for (var j = 0; j < 5; j++) {
                if (j < items.length) {
                  allItems.push(items[j])
                }
              }
              if (items.length >= 5) {
                allItems.push({
                  image: {
                    path: '' // ImageMoreBg
                  },
                  isMore: true
                })
              }
            }
            this.shows = allItems
          } else {
            this.error = 'Invalid content.'
          }
        })
      }
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// section show

.section-show {
  // margin-top: 3em;
  // margin-bottom: 3em;

  .columns {
    // margin-top: 1.5em;

    .show-title-wrapper {
      position: relative;
      border-bottom: 2px solid gray;
      .show-title-content {
        position: absolute;
        width: 100%;
        bottom: -1.26em;
        .show-title {
          display: inline-block;
          padding: 3px 8px;
          background-color: white;
          color: black;
          font-size: 1.4em;
          font-family: $font-family-title;
          text-transform: uppercase;
        }
      }
    }

    .show-wrapper {
      // margin-bottom: 2em;

      .show-content {
        position: relative;

        .show-image-wrapper {

          a {
            // // extension
            // img, .image {
            //   display: inline-block;
            //   filter: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#grayscale"); /* Firefox 3.5+ */
            //   filter: gray; /* IE6-9 */
            //   -webkit-filter: grayscale(100%); /* Chrome 19+ & Safari 6+ */
            //
            //   &:hover {
            //     filter: none;
            //     -webkit-filter: grayscale(0%);
            //   }
            // }

            .show-text-overlay {
              position: absolute;
              top: 0%;
              width: 100%;
              height: 100%;
              transition: all .3s ease;
              background-color: rgba(0,0,0,0.4);
              opacity: 0.01;
              visibility: hidden;

              .show-text-wrapper {
                position: absolute;
                width: 100%;
                top: 45%;

                @media screen and (min-width: $tablet - 1) {
                  top: 50%;
                }

                @media screen and (min-width: $desktop) {
                  top: 50%;
                }
              }
            }

            &:hover .show-text-overlay {
              // background-color: rgba(0,0,0,0.0);
              opacity: 1.0;
              visibility: visible;
            }

            & .show-text-overlay.visible {
              opacity: 1.0;
              visibility: visible;
            }
          }

          // .show-text-wrapper {
          //   position: absolute;
          //   top: 0%;
          //   width: 100%;
          //   height: 100%;
          //   text-align: center;
          //   background-color: rgba(255,255,255,0.5);
          //   // display: none;
          //   transition: opacity 0.5s;
          //   -webkit-transition: opacity 0.5s;
          //
          //   &:hover {
          //     // display: inline-block;
          //     background-color: rgba(255,255,255,0.0);
          //     transition: opacity 0.5s;
          //     -webkit-transition: opacity 0.5s;
          //   }
          //
          //   .show-text-overlay {
          //     position: absolute;
          //     top: 30%;
          //   }
          // }
        }

        .see-all-wrapper {
          position: absolute;
          top: 50%;
          width: 100%;
          color: white;
          margin: auto;
          pointer-events: none;

          div {
            width: 100px;
            border: 2px solid white;
            padding: 3px 10px;
            margin-left: auto;
            margin-right: auto;
            font-size: 1.1em;
            font-family: $font-family-title;
            pointer-events: none;
          }
        }

        // margin-left: 2px;
        // margin-right: 2px;
        // @media screen and (min-width: $desktop) {
        //   margin-right: 8px;
        // }

        .date {
          text-transform: uppercase;
          color: $color-gray;
          font-size: 0.9em;

          display: inline-block;
          margin-top: 1.5em;
        }

        .title {
          // text-transform: uppercase;
          text-transform: none;
          color: white;
          display: inline-block;
          line-height: 1.2em;
          margin-bottom: 0.5em;
          font-weight: 500;
          font-size: 1.0em;

          @media screen and (min-width: $tablet - 1) {
            font-size: 1.2em;
          }

          @media screen and (min-width: $desktop) {
            font-size: 1.2em;
          }
        }

        .subtitle {
          text-transform: uppercase;
          color: white;
          display: inline-block;
          line-height: 1.2em;
          font-weight: normal;
          font-size: 0.7em;

          @media screen and (min-width: $tablet - 1) {
            font-size: 0.9em;
          }

          @media screen and (min-width: $desktop) {
            font-size: 0.9em;
          }
        }

        .button.buy-ticket {
          color: white;
          display: inline-block;
          padding: 8px 25px;
          height: 3.2em;
          font-size: 0.7em;
          margin-top: 0.8em;
          background-color: $color-primary-green;

          &.is-blue {
            background-color: $color-primary-blue;
          }

          &.is-red {
            background-color: $color-primary-red;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// ShowSection.vue?28eafb3f